var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('upload-authorization-file',{ref:"UploadAuthorizationFile",attrs:{"upload-mode":"fileId","preview-api":_vm.previewBlacklistFileApi,"download-api":_vm.downloadBlacklistFileApi,"translate-data":{
    downloadTranslate: 'url'
  },"props-data":Object.assign({}, {limit: 1},
    _vm.propsValue),"request-params":_vm.requestParamsValue},model:{value:(_vm.attachmentGroupIdTemp),callback:function ($$v) {_vm.attachmentGroupIdTemp=$$v},expression:"attachmentGroupIdTemp"}})}
var staticRenderFns = []

export { render, staticRenderFns }